import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button, Typography } from "@material-ui/core";
export class DeleteModal extends React.Component {
    constructor(props) {
        super(props);
        let text =
            "Removing a Qualification From Required Qualifications Will Delete All Associated Qualification Data For All Users.";
        this.state = {
            text1: text,
            text2: "Removing A Qualification Is Non Reversible! ",
            text,
            count: 0
        };
    }
    render() {
        const { deleteModalInfo } = this.props;

        return (
            <div>
                <Modal isOpen={deleteModalInfo.modalOpen}>
                    <ModalHeader>Delete Qualification </ModalHeader>
                    <ModalBody>
                        <div
                            style={{
                                width: "100%"
                            }}
                        >
                            <Typography style={{ marginBottom: 10 }} variant="body2">
                                <b>{this.state.text}</b>
                            </Typography>
                            <Typography style={{ marginBottom: 10 }} variant="body1">
                                Are You Sure You Wish To Proceed?
                            </Typography>
                            <Typography variant="body2">
                                Title: <b>{deleteModalInfo.qualTitle}</b>
                            </Typography>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <Button
                                onClick={() => {
                                    this.props.setDeleteModalInfo("", "", false);
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    if (this.state.count === 1) {
                                        this.props.setDeleteModalInfo("", "", false);
                                        this.props.setQualificationToDeselected(
                                            deleteModalInfo.qualID
                                        );
                                        this.props.deleteQualificationFromRequiredQualifications(
                                            deleteModalInfo.qualID
                                        );
                                        this.removeQualificationFromUsers(deleteModalInfo.qualID);
                                        this.setState({ count: 0, text: this.state.text1 });
                                    } else {
                                        this.setState({
                                            text: this.state.text2,
                                            count: this.state.count + 1
                                        });
                                    }
                                }}
                            >
                                Remove
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
    removeQualificationFromUsers = qualID => {
        const { allUsers } = this.props;
        Object.keys(allUsers).map(e => {
            this.props.deleteQualificationFromUsers(qualID, e);
            return true;
        });
    };
}
